import { request } from '@/network/request'

// 我的粉丝列表
export const myFans = (data) => {
  return request({
    url: '/api/promoters/tWzaiAiProduct/getMyFans',
    method: 'post',
    params: data
  })
}

// 收益明细
export const incomeDetails = (data) => {
  return request({
    url: '/intelligentDetection/user/incomeDetails',
    method: 'get',
    params: data
  })
}


// WEBPACK FOOTER //
// ./src/api/fsHistoryChange.js